import React, {useEffect, useState} from "preact/compat";
import Interactable from "../canvas/interactable";
import util from "../util";
import AsidePrint from "./AsidePrint";
import { fitToPage } from "../canvas/zoom";
// import Spinner from "./Spinner";

export default function AppAsideRight({view, onClose, designSize, pages, paperSize, designId, designName, memberId, locationId, setShowExitWarning, isMobileVersion, templateId, showMatchingDesignsModal}: any) {

  useEffect(() => {
    $('body').addClass('print-open');
    fitToPage();
    util.nextTick(() => Interactable.adjustSelectionBoxes());
    
    return () => {
      $('body').removeClass('print-open');
      util.nextTick(() => Interactable.adjustSelectionBoxes());
    }
  }, []);

  return (
    <aside id="app-aside-right" className={`main right print ${!isMobileVersion ? 'slide-in-right' : ''}`}>
        <div className="content">
          {view === 'print' && 
            <AsidePrint 
              view={view} 
              onClose={onClose}
              designSize={designSize}
              paperSize={paperSize}
              pages={pages}
              designId={designId}
              templateId={templateId}
              designName={designName} 
              memberId={memberId}
              locationId={locationId}
              setShowExitWarning={setShowExitWarning}
              showMatchingDesignsModal={showMatchingDesignsModal}
              isMobileVersion={isMobileVersion} />
          }
        </div>
      </aside>
  )
}
